// extracted by mini-css-extract-plugin
export var addToCartButton = "_pn-b";
export var arrowButtonContainer = "_pn-9";
export var arrowButtonIcon = "_pn-a";
export var carouselArrowButton = "_pn-6";
export var carouselElementContainer = "_pn-1";
export var left = "_pn-7";
export var productDisplayCarouselContainer = "_pn-0";
export var productTileContainer = "_pn-2";
export var productTileImage = "_pn-4";
export var productTileImageContainer = "_pn-3";
export var productTileTitle = "_pn-5";
export var right = "_pn-8";
export var sliderOverflow = "_pn-c";